import type { Visibility } from './visibility.js';

export type ProjectStatus = '試作' | '検証中' | '利用中' | '改善中' | '停止中';

export const PROJECT_STATUSES: readonly ProjectStatus[] = [
  '試作',
  '検証中',
  '利用中',
  '改善中',
  '停止中',
] as const;

export interface Project {
  id: string;
  name: string;
  description: string;
  status: ProjectStatus;
  color: string;
  visibility: Visibility;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  /** 集計表示用キャッシュ（任意。MVP では未使用） */
  links?: number;
  questions?: number;
  notes?: number;
  apps?: number;
  tips?: number;
}
